/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WorkflowStageTaskNeedsCompletedCountViewModel } from './WorkflowStageTaskNeedsCompletedCountViewModel'; 

export function getWorkflowStageNeedsCompletedCountOptions(stayId: string, onSuccess?: (result: WorkflowStageTaskNeedsCompletedCountViewModel) => void) {
	return queryOptions({
		queryKey: ['workflow-stage-needs-completed-count', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/workflows/queries/getworkflowstageneedscompletedcount/' + stayId;
			const resp = await axios.get<WorkflowStageTaskNeedsCompletedCountViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}